import {ProductWithNodes} from '../../../types';
import translate from '../../../utils/getTranslation';

type Props = {
  storefrontProduct: ProductWithNodes;
};

export default function Difficulty({storefrontProduct}: Props) {
  const metafields = storefrontProduct.metafields;

  const getDifficulty = (value: string) => {
    let num = parseInt(value);
    const ranges = [
      {name: translate('BEGINNER'), start: 0, end: 19},
      {name: translate('INTERMEDIATE'), start: 20, end: 49},
      {name: translate('ADVANCED'), start: 50, end: 79},
      {name: translate('EXPERT'), start: 80, end: 100},
    ];

    let difficulty;

    ranges.map((range) => {
      if (num >= range.start && num <= range.end) {
        difficulty = range.name;
      }
    });

    return difficulty;
  };

  return (
    <div className="mt-8 grid gap-4">
      {metafields &&
        metafields.map((metafield, index) => {
          if (!metafield) return null;
          if (metafield?.namespace === 'difficulty')
            return (
              <div key={index}>
                <div className="mb-2 flex justify-between text-xs">
                  <p>{translate(metafield.key.toUpperCase())}</p>
                  <p>{getDifficulty(metafield.value)}</p>
                </div>
                <div className="relative h-[1px] w-full bg-neutral-300">
                  <div
                    className="absolute bottom-0 h-[1px] bg-neutral-900"
                    style={{width: `${metafield.value}%`}}
                  />
                </div>
              </div>
            );
        })}
    </div>
  );
}
